import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Sidebar, SidebarSectionName } from '@/shared/modules/layout';
import { useAccess, useAppReadLocalStorage } from '@/warehouse/hooks';
import { appSections, sidebarNavigationItems } from '@/warehouse/navigation';
import { Fragment, useMemo } from 'react';
import { useLayoutStore } from '@/shared/modules/layout/business';
import { SidebarMenuItem } from '@/shared/modules/layout/components';
import { warehouseAppSidebarWidth } from '@/warehouse/constants';
import { getNavigationItemsForUser } from '@/warehouse/helpers';
const AppSidebar = () => {
    const { userHasAccessTo } = useAccess();
    const sidebarCollapsed = useLayoutStore((state) => state.sidebarCollapsed);
    const activeCrossdockId = useAppReadLocalStorage({ key: 'crossDockId', initialValue: 0 });
    const activeStockLocationId = useAppReadLocalStorage({ key: 'stockLocationId', initialValue: 0 });
    const userNavigationItems = useMemo(() => getNavigationItemsForUser(appSections, sidebarNavigationItems, userHasAccessTo), [userHasAccessTo]);
    return (_jsx(Sidebar, { sidebarWidth: warehouseAppSidebarWidth, children: 
        // Crossdock or location can be undefined if user haven't ever had access to it.
        (activeCrossdockId || activeStockLocationId) &&
            userNavigationItems.map((navigationGroup, index) => {
                const { menuItems, groupName } = navigationGroup;
                return (_jsxs(Fragment, { children: [groupName && (_jsx(SidebarSectionName, { isFirst: index === 0, hidden: sidebarCollapsed, children: groupName })), navigationGroup.element && _jsx(navigationGroup.element, {}), menuItems.map((sectionKey) => {
                            const { id, menuItemTitle, title, getLinkTo, icon, groups } = appSections[sectionKey];
                            const linkTo = getLinkTo(groups.includes('crossdocking') ? activeCrossdockId : activeStockLocationId);
                            return (_jsx(SidebarMenuItem, { 
                                // TODO: return!! when reclamations are ready
                                // linkTo={linkTo}
                                // linkTo={linkTo !== '/reclamations' ? linkTo : '#'}
                                // linkTo={linkTo.indexOf('/reclamations') !== -1 ? linkTo : '#'}
                                linkTo: linkTo, icon: icon, title: menuItemTitle ?? title, 
                                // TODO: to delete later
                                // allow={claimIds}
                                collapsed: sidebarCollapsed }, `menuItem_${id}`));
                        })] }, `section_${groupName}_${index}`));
            }) }));
};
export { AppSidebar };
